<!-- Start: Rejwan: 08-04-2026 Early loan settlement -->
<template>
    <div class="pb-3">
        <b-overlay :show="showoverlay_list" rounded="sm">  
            <template>
                <div v-if="loans.length>0">
                    <common-list :pageurl="this.$api_url" :checkbox="checkbox"  :is_action="is_action" :appended_column="appended_column" is_pf="1" :key="list_key" :company_options="company_options" :employees="loans" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list> 
                </div>
                <div v-else>
                    <div v-if="show_loader" class="list-no-data">
                        <span class="d-block text-center">Looking for relevant data..</span>
                        <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                    </div>
                    <div v-else class="list-no-data">
                        Looks like there is no PF early settlement to show.
                    </div>
                </div>
            </template>
        </b-overlay>

        <b-modal id="bv-modal-early-settlement-details" size="md" hide-footer v-bind:title="modal_title"> 
            <pf-loan-early-settlement-details :flg="flg" :early_settlement_id ="early_settlement_id" :employee_id="emp_id" :employee_name="emp_name" :loan_id="loan_id" :early_settlement_status="early_settlement_status" v-on:childToParent="getLoanEarlySettlementData"></pf-loan-early-settlement-details>           
        </b-modal>
    </div>
</template>


<script>
    export default{
        mounted() {

        },
        props: ['pageurl','flg','is_trustee'],
        data(){            
            
            return {
                
                loans:[], 
                loan_id:'',
                employee_id:'',
                tx_popup_count:0,
                styleA: 'color:#55ce63 !important',
                styleB: 'color:#009efb !important',     
                modal_title:'',
                showoverlay_list : false,                          
  
                show_loader:true,
                 /**Child Component property data */
                is_action:1,
                checkbox:0, 
                list_key:0,
                loans:[],   
                default_column:['name','employee_code'],
                appended_column:[
                    { value: "company_loan_id", text: "Advance ID",type: "text"},
                    { value: "remaining_amount", text: "Amount",type: "amount"},
                    { value: "early_settlement_date", text: "Application Date",type: "date"},
                    { value: "early_settlement_status", text: "Status",type: "text"},
                ],
                primary_key:'id', 
                company_options:[],
                tmp_loans_early_settlement:[],
                approver_settings:[],
                /***Child Component property data */

                emp_id:'',
                emp_name:'',
                preview_list:[],
                show_bank_preview:false,
                early_settlement_id: '',
                modal_key: 0,
                early_settlement_status: '',
            }
        },
        methods:{
            listReturn:function(data)
            {
                if(data.selected.length > 0)
                {
                    this.selected = data.selected;
                }
                else
                {
                    this.selected = [];
                    if(data.id > 0)
                    {
                        var item  = this.loans.find(item => item.id === data.id); 
                        if(data.action_id == 1)
                        {
                            this.showEarlySettlementDetails(item)
                        }
                    }

                }
            },
            showEarlySettlementDetails: function(item) {
                this.early_settlement_id = item.id;
                this.loan_id = item.loan_id;
                this.emp_id = item.employee_id;
                this.emp_name = item.name ? item.name : '';
                this.modal_title = 'Early Settlement Details';
                this.early_settlement_status = item.early_settlement_status;
                this.modal_key = this.modal_key + 1;

                this.$bvModal.show('bv-modal-early-settlement-details');
            },
            getLoanEarlySettlementData: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                currentObj.show_loader = true;
                
                axios.get(this.$api_url+'/pf/loan/early-settlement/list' , {
                }).then(function(response){
                    currentObj.tmp_loans_early_settlement = response.data.employee_data;
                     currentObj.company_options = response.data.options;
                    
                    if(currentObj.tmp_loans_early_settlement.length > 0 )
                    {
                        currentObj.tmp_loans_early_settlement.forEach(element => {
                            if(element.id > 0)
                            {
                                let dop = []; 
                                dop = dop.concat([{ label: 'View Details' , value: 1 }]);
                                element.actions = dop;
                            }
                        });
                        
                    }
                    currentObj.$bvModal.hide('bv-modal-early-settlement-details');
                    if(this.is_trustee != null && this.is_trustee == 1)
                    {
                        this.is_action = 0;
                    }
                    currentObj.loans = currentObj.tmp_loans_early_settlement;
                    currentObj.list_key = currentObj.list_key + 1;
                    
                    currentObj.show_loader = false;
                }.bind(this)).catch(function (error){ 
                    currentObj.show_loader = false;
                    currentObj.serverError(error);
                });

            },
            
        },
        created: function(){
            this.getLoanEarlySettlementData();
        }
    }
</script>
<!-- End: Rejwan: 08-04-2026 Early loan settlement -->
